import React, { memo } from 'react';
import { PageSwitcherTypes } from '@app/router';
import { Text, Box, Center, Flex } from '@stockx/ui';
import NavItem from './components/NavItem';
import { MenuItem } from '../../../../types/menu';

type MenuItemProps = {
  item: MenuItem;
  isActive: boolean;
  handleOnClick: (MenuItem) => void;
};

const Title = ({ children }) => (
  <Text
    fontSize="sm"
    fontFamily="suisseIntlMedium"
    color="neutral.black"
    lineHeight="19px"
    marginBottom="1"
  >
    {children}
  </Text>
);

const Description = ({ children }) => (
  <Text
    fontSize="xs"
    fontWeight="300"
    color="neutral.500"
    letterSpacing="0"
    lineHeight="1rem"
  >
    {children}
  </Text>
);

const Wrapper = ({ children, isActive, ...props }) => (
  <Box
    backgroundColor={isActive ? 'neutral.white' : 'initial'}
    _before={{
      background: 'none !important',
    }}
    _hover={{
      backgroundColor: 'neutral.200',
      color: 'green.700',
    }}
    px={6}
    py={3}
    {...props}
  >
    {children}
  </Box>
);

const ListMenuItem = ({ item, isActive, handleOnClick }: MenuItemProps) => (
  <Wrapper
    isActive={isActive}
    onClick={
      handleOnClick
        ? () => {
            handleOnClick(item);
          }
        : undefined
    }
  >
    <NavItem
      href={item.path}
      isExternal={item.linkType === PageSwitcherTypes.External}
    >
      <Flex>
        <Center>{!!item.icon && item.icon}</Center>
        <Box>
          <Title>{item.title}</Title>
          {!!item?.description && <Description>{item.description}</Description>}
        </Box>
      </Flex>
    </NavItem>
  </Wrapper>
);

export default memo(ListMenuItem);
